import React, { Component } from "react";
import { Link } from "react-router-dom";

class MenuEmpresa extends Component {
  render() {
    return (
      <li className="nav-item">
        <Link to="/empresa/consulta" className="nav-link">
          <i className="link-icon icon-grid" />
          <span className="menu-title">Empresa</span>
          <i className="menu-arrow" />
        </Link>
        <div className="submenu">
          <ul className="submenu-item">
            <li className="nav-item">
              <Link className="nav-link" to="/empresa/consulta">
                Consultar
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to={{ pathname: "/empresa/cadastro", state: "refresh" }}>
                Novo Cadastro
              </Link>
            </li>
          </ul>
        </div>
      </li>
    );
  }
}

export default MenuEmpresa;
